import React from 'react';
import Pill from 'components/Pill';
import { useTranslation } from 'react-i18next';
export function AdminPill() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Pill, {
    icon: "eye-closed",
    iconColor: "disabled"
  }, t('state_only_admins'));
}
export function EveryonePill() {
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(Pill, {
    icon: "eye-open",
    iconColor: "positive"
  }, t('state_everyone'));
}